// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("css/" + "vendor" + "." + "8954bfa5926faa28e979" + ".css");